"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container flex-col" };
const _hoisted_2 = {
    key: 0,
    class: "h2-title"
};
const _hoisted_3 = {
    key: 1,
    class: "h2-title"
};
const _hoisted_4 = { class: "flex-container" };
const _hoisted_5 = { class: "left-side" };
const _hoisted_6 = { class: "divided-col" };
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { class: "col" };
const _hoisted_9 = { class: "divided-col" };
const _hoisted_10 = { class: "col" };
const _hoisted_11 = { class: "col" };
const _hoisted_12 = ["selected", "value"];
const _hoisted_13 = ["value", "selected"];
const _hoisted_14 = ["selected", "value"];
const _hoisted_15 = { class: "right-side" };
const _hoisted_16 = { class: "button-row" };
const Form_1 = require("../../../components/Form");
const CustomTextArea_vue_1 = __importDefault(require("../../../components/backend/CustomTextArea.vue"));
const CustomSelect_vue_1 = __importDefault(require("../../../components/backend/CustomSelect.vue"));
const Card_vue_1 = __importDefault(require("../../../components/backend/Card/Card.vue"));
const CustomSwitch_vue_1 = __importDefault(require("../../../components/backend/CustomSwitch.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
const vue_router_1 = require("vue-router");
const vue_3 = require("vue");
//import { debounce } from "lodash";
const companyServicesStore_1 = require("../../../stores/backend/companyService/companyServicesStore");
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
const serviceTypeStore_1 = require("../../../stores/backend/serviceType/serviceTypeStore");
const serviceBayTypeStore_1 = require("../../../stores/backend/serviceBayType/serviceBayTypeStore");
const serviceSubTypeStore_1 = require("../../../stores/backend/serviceSubType/serviceSubTypeStore");
const vue_4 = require("vue");
const vue_router_2 = require("vue-router");
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ServiceForm',
    setup(__props) {
        var _a;
        const router = (0, vue_router_2.useRouter)();
        const instance = (0, vue_4.getCurrentInstance)();
        const isError = (0, vue_3.ref)(false);
        const $trans = (_a = instance === null || instance === void 0 ? void 0 : instance.proxy) === null || _a === void 0 ? void 0 : _a.$trans;
        const route = (0, vue_router_1.useRoute)();
        const id = route.params.id ? parseInt(route.params.id, 10) : null;
        const serviceStore = (0, companyServicesStore_1.useCompanyServicesStore)();
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        const serviceTypeStore = (0, serviceTypeStore_1.useServiceTypeStore)();
        const serviceBayTypeStore = (0, serviceBayTypeStore_1.useServiceBayTypeStore)();
        const serviceSubTypeStore = (0, serviceSubTypeStore_1.useServiceSubTypeStore)();
        const detaildServiceCopy = (0, vue_3.ref)(null);
        (0, vue_3.watch)(() => serviceStore.detaildService, (newValue) => {
            detaildServiceCopy.value = newValue;
        }, { immediate: true });
        (0, vue_3.onBeforeMount)(() => {
            serviceTypeStore.fetchServiceTypes();
            serviceBayTypeStore.fetchServiceBayTypes();
            serviceSubTypeStore.fetchServiceSubTypes();
            if (id !== null) {
                serviceStore.fetchDetailedService(id);
            }
            else {
                serviceStore.clearDetaildService();
            }
        });
        // Egy tömb, amely meghatározza az oszlopokat
        const switches = Array.from({ length: 13 }, (_, i) => i + 12);
        const switchGroups = Array.from({ length: Math.ceil(switches.length / 5) }, (_, i) => switches.slice(i * 5, i * 5 + 5));
        function formatForTrans(type) {
            return type.replace(/ /g, "_").toLowerCase();
        }
        /*const debouncedHandleInputChange = debounce(
            <K extends keyof detaildServiceInterface>(
                key: K,
                value: detaildServiceInterface[K]
            ) => {
                if (
                    detaildServiceCopy.value &&
                    detaildServiceCopy.value[key] !== undefined &&
                    value !== undefined
                ) {
                    detaildServiceCopy.value[key] = value;
                }
            },
            500
        );*/
        // **Bevitel feldolgozása**
        const handleInputForPrice = (key, value) => {
            const numericValue = value
                .replace(/[^0-9.]/g, "") // csak szám és pont
                .replace(/(\..*)\./g, "$1"); // második (további) pont eltávolítása*/
            handleInputChange(key, numericValue);
        };
        const handleInputChange = (key, value) => {
            if (detaildServiceCopy.value &&
                detaildServiceCopy.value[key] !== undefined &&
                value !== undefined) {
                detaildServiceCopy.value[key] = value;
            }
        };
        const changeServiceCol = (e) => {
            if (!detaildServiceCopy.value) {
                return; // Kilépünk, ha null
            }
            const value = parseInt(e.target.value, 10); // Az érték számra konvertálása
            if (e.target.checked) {
                // Hozzáadás a coll tömbhöz, ha még nincs benne
                if (!detaildServiceCopy.value.coll.includes(value)) {
                    detaildServiceCopy.value.coll.push(value);
                }
            }
            else {
                // Eltávolítás a coll tömbből
                detaildServiceCopy.value.coll = detaildServiceCopy.value.coll.filter((item) => item !== value);
            }
            detaildServiceCopy.value.coll.sort((a, b) => Number(a) - Number(b));
        };
        const changeServiceSubType = (e) => {
            if (!detaildServiceCopy.value) {
                return; // Kilépünk, ha null
            }
            const tmpServiceType = serviceSubTypeStore.serviceSubTypes.find((serviceSubType) => Number(serviceSubType.id) === Number(e.target.value));
            if (e.target.checked && tmpServiceType) {
                detaildServiceCopy.value.serviceSubType.push(tmpServiceType === null || tmpServiceType === void 0 ? void 0 : tmpServiceType.name);
            }
            else if (tmpServiceType) {
                detaildServiceCopy.value.serviceSubType =
                    detaildServiceCopy.value.serviceSubType.filter((item) => item !== tmpServiceType.name);
            }
        };
        const changeRunflat = (e) => {
            if (!detaildServiceCopy.value) {
                return; // Kilépünk, ha null
            }
            detaildServiceCopy.value.runflat = e.target.checked;
        };
        const changeAssignedLocations = (e) => {
            if (!detaildServiceCopy.value) {
                return; // Kilépünk, ha null
            }
            const tmpLocation = companyLocationStore.locations.find((location) => Number(location.id) === Number(e.target.value));
            if (e.target.checked && tmpLocation) {
                detaildServiceCopy.value.assignedLocations.push(tmpLocation);
            }
            else if (tmpLocation) {
                detaildServiceCopy.value.assignedLocations =
                    detaildServiceCopy.value.assignedLocations.filter((item) => item.id !== tmpLocation.id);
            }
        };
        const checkDigit = (event) => {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Engedélyezett kombinációk (Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + Z, Ctrl + A)
            if ((event.ctrlKey || event.metaKey) &&
                ["a", "c", "v", "x", "z"].includes(event.key.toLowerCase())) {
                return;
            }
            // Engedjük a pontot (.) csak ha még nincs a mezőben
            if (event.key === ".") {
                const target = event.target;
                if (target.value.includes(".")) {
                    event.preventDefault();
                }
                return;
            }
            // Ha nem szám és nem engedélyezett gomb, tiltsuk
            if (event.key.length === 1 &&
                Number.isNaN(Number(event.key)) &&
                !allowedKeys.includes(event.key)) {
                event.preventDefault();
            }
        };
        // Beillesztés ellenőrzése
        const checkPaste = (event) => {
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData("text");
            // Ha a beillesztett szöveg nem teljes egészében szám, akkor blokkoljuk
            if (!/^\d+$/.test(pastedText)) {
                event.preventDefault();
                if ($trans) {
                    alert($trans("paste_number_error", "You can only insert numbers!", "services_list"));
                }
                else {
                    alert("You can only insert numbers!");
                }
            }
        };
        const saveAndRedirect = async () => {
            var _a, _b;
            const result = await serviceStore.saveService(detaildServiceCopy.value, (_b = (_a = companyLocationStore.selectedCompany) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
            if (result.success) {
                router.push({
                    name: "services",
                    query: { success: "true", id: result.id },
                });
            }
            else {
                isError.value = true;
            }
        };
        const deleteAndRedirect = async () => {
            var _a, _b;
            const confirmed = window.confirm("Biztosan törlöd ezt a szolgáltatást?");
            if (confirmed === true) {
                if ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.id) {
                    const result = await serviceStore.deleteService((_b = detaildServiceCopy.value) === null || _b === void 0 ? void 0 : _b.id);
                    if (result.success) {
                        router.push({
                            name: "services",
                            query: { deleted: "true" },
                        });
                    }
                }
            }
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (isError.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: (0, vue_2.unref)($trans)('service_save_error_message', 'Unexpected error', 'service_list'),
                        variant: "danger",
                        class: "rounded-t-none",
                        "icon-class": "marso-icon-exclamation-circle"
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.id) == null)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h2", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("new_service", "New Service", "services_list")), 1))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h2", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("edit_service", "Edit Service", "services_list")) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(serviceStore).detaildService.name) + " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("identifier", "Identifier", "services_list")) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(serviceStore).detaildService.id) + ") ", 1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                name: "szolg_name",
                                label: (0, vue_2.unref)($trans)('service_name', 'Service Name', 'services_list'),
                                "model-value": detaildServiceCopy.value ? detaildServiceCopy.value.name : '',
                                onKeyup: _cache[0] || (_cache[0] = ($event) => (handleInputChange('name', $event.target.value)))
                            }, null, 8, ["label", "model-value"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                        name: "szolg_price",
                                        currency: "Ft",
                                        label: (0, vue_2.unref)($trans)('service_price', 'Service price', 'services_list'),
                                        "model-value": (_c = Number((_b = detaildServiceCopy.value) === null || _b === void 0 ? void 0 : _b.price)) !== null && _c !== void 0 ? _c : '',
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                            (value) => handleInputForPrice('price', value)),
                                        onKeydown: checkDigit,
                                        onPaste: checkPaste
                                    }, null, 8, ["label", "model-value"])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                        name: "szolg_price_online",
                                        currency: "Ft",
                                        label: (0, vue_2.unref)($trans)('service_online_price', 'Service online price', 'services_list'),
                                        "model-value": (_e = Number((_d = detaildServiceCopy.value) === null || _d === void 0 ? void 0 : _d.onlinePrice)) !== null && _e !== void 0 ? _e : '',
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] =
                                            (value) => handleInputForPrice('onlinePrice', value)),
                                        onKeydown: checkDigit,
                                        onPaste: checkPaste
                                    }, null, 8, ["label", "model-value"])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_2.createVNode)(CustomTextArea_vue_1.default, {
                                        name: "description",
                                        class: "text-area",
                                        label: (0, vue_2.unref)($trans)('description', 'Description', 'services_list'),
                                        rows: 10,
                                        value: detaildServiceCopy.value
                                            ? detaildServiceCopy.value.description
                                            : '',
                                        onKeyup: _cache[3] || (_cache[3] = ($event) => (handleInputChange('description', $event.target.value)))
                                    }, null, 8, ["label", "value"])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                        active: false,
                                        name: "szolg_type",
                                        label: (0, vue_2.unref)($trans)('service_type', 'Service type', 'services_list'),
                                        onChange: _cache[4] || (_cache[4] = (e) => handleInputChange('serviceTypeId', parseInt(e.target.value)))
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(serviceTypeStore).serviceTypes, (type) => {
                                                var _a;
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: type.id,
                                                    selected: type.id ===
                                                        ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.serviceTypeId),
                                                    value: type.id
                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)($trans)(formatForTrans(type.type), type.type, "services_list")), 9, _hoisted_12));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                        name: "station_type",
                                        label: (0, vue_2.unref)($trans)('bay_type', 'Bay type', 'services_list'),
                                        active: false,
                                        onChange: _cache[5] || (_cache[5] = (e) => handleInputChange('serviceBayType', parseInt(e.target.value)))
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(serviceBayTypeStore).serviceBayTypes, (type) => {
                                                var _a;
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: type.id,
                                                    value: type.id,
                                                    selected: type.id ===
                                                        ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.serviceBayType)
                                                }, (0, vue_2.toDisplayString)(type.type), 9, _hoisted_13));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                        name: "time",
                                        label: (0, vue_2.unref)($trans)('duration', 'Duration', 'services_list'),
                                        onChange: _cache[6] || (_cache[6] = (e) => handleInputChange('duration', parseInt(e.target.value)))
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Array.from({ length: Math.floor(180 / 15) }, (_, index) => (index + 1) * 15), (i) => {
                                                var _a;
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: i,
                                                    selected: i === ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.duration),
                                                    value: i
                                                }, (0, vue_2.toDisplayString)(i) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("minute", "minute", "services_list")), 9, _hoisted_14));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["label"])
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createVNode)(Card_vue_1.default, {
                                "custom-class": "service-card",
                                label: (0, vue_2.unref)($trans)('assigned_locations', 'Assigned Locations', 'services_list')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(companyLocationStore).locations, (location) => {
                                        var _a;
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomSwitch_vue_1.default, {
                                            key: location.id,
                                            checked: ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.assignedLocations.some((assigned) => {
                                                return (Number(assigned.id) ===
                                                    Number(location.id));
                                            })) || false,
                                            name: "assigned_locations[]",
                                            value: location.id,
                                            text: location.name,
                                            onChange: changeAssignedLocations
                                        }, null, 8, ["checked", "value", "text"]));
                                    }), 128))
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            (0, vue_2.createVNode)(Card_vue_1.default, {
                                "custom-class": "service-card",
                                label: (0, vue_2.unref)($trans)('options', 'Options', 'services_list')
                            }, {
                                default: (0, vue_2.withCtx)(() => {
                                    var _a, _b;
                                    return [
                                        (0, vue_2.createVNode)(CustomSwitch_vue_1.default, {
                                            name: "runflat",
                                            text: (0, vue_2.unref)($trans)('runfalt_service', 'Runflat service', 'services_list'),
                                            value: ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.runflat) ? true : false,
                                            checked: ((_b = detaildServiceCopy.value) === null || _b === void 0 ? void 0 : _b.runflat) ? true : false,
                                            onChange: changeRunflat
                                        }, null, 8, ["text", "value", "checked"]),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(serviceSubTypeStore).serviceSubTypes, (subType) => {
                                            var _a;
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomSwitch_vue_1.default, {
                                                key: subType.id,
                                                name: "service_sub_types[]",
                                                value: subType.id,
                                                text: subType.name,
                                                checked: ((_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.serviceSubType.some((assignedSubType) => {
                                                    return assignedSubType === subType.name;
                                                })) || false,
                                                onChange: changeServiceSubType
                                            }, null, 8, ["value", "text", "checked"]));
                                        }), 128))
                                    ];
                                }),
                                _: 1
                            }, 8, ["label"]),
                            (0, vue_2.createVNode)(Card_vue_1.default, {
                                "custom-class": "switch-card",
                                label: "Átmérő"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(switchGroups), (row, rowIndex) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: rowIndex,
                                            class: "card-col"
                                        }, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(row, (col) => {
                                                var _a;
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomSwitch_vue_1.default, {
                                                    key: col,
                                                    name: 'colls[]',
                                                    text: `${col} coll`,
                                                    value: col,
                                                    checked: (_a = detaildServiceCopy.value) === null || _a === void 0 ? void 0 : _a.coll.includes(col),
                                                    onChange: changeServiceCol
                                                }, null, 8, ["text", "value", "checked"]));
                                            }), 128))
                                        ]));
                                    }), 128))
                                ]),
                                _: 1
                            }),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                                    "btn-type": "success",
                                    onClick: saveAndRedirect
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("save", "Save", "services_list")), 1)
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                                    "btn-type": "danger",
                                    onClick: deleteAndRedirect
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)($trans)("delete", "Delete", "services_list")), 1)
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
